module.exports = __webpack_public_path__ + "static/pA1-c6785550256ff16f0c5a5072cbcba3a5.png";